export class Clipboard {
  public static async copyToClipboard(containerid: string) {
    if (navigator.clipboard) {
      const element = document.getElementById(containerid);
      if (element == null) return false;

      const data = element.innerText;
      await navigator.clipboard.writeText(data);
      return true;
    } else {
      if ((window as any).getSelection) {
        const range = document.createRange();

        //console.log('execCommand containerid=' + containerid);
        const element = document.getElementById(containerid);
        if (element == null) return false;
        console.log(element, 'element node');
        range.selectNode(element);
        (window as any).getSelection().addRange(range);
        const result = document.execCommand('copy');
        console.log('copy result=' + result);

        (window as any).getSelection().removeAllRanges();

        return true;
      }
    }
    return false;
  }

  public static async copyTextToClipboard(data: string, id?: string) {
    if (navigator.clipboard) {
      console.log(data, '<=navigator.clipboard.writeText');
      await navigator.clipboard.writeText(data);
      return true;
    } else {
      if (id === undefined || id == null) return false;

      let element = document.getElementById(id) as HTMLInputElement;

      if (element === null || element === undefined) {
        document.body.append(`<input type='text' style='display:none;' id="${id}" >`);
        element = document.getElementById(id) as HTMLInputElement;
        if (element === null || element === undefined) return false;
        element.innerHTML = data;
        element.select();
      } else {
        element.innerHTML = data;
        element.select();
      }

      if (element) {
        setTimeout(() => {
          document.removeChild(element);
        }, 50000);
      }

      return Clipboard.copyToClipboard(id);
    }
  }
}
